<template>
  <div>
    <div class="uploadList" v-if="type !== 'view'">
      <el-upload
        class="upload-file"
        :class="{ 'upload-image': uploadType != 'button' }"
        action=""
        ref="upload"
        :accept="uploadParams.accept.join(',')"
        :multiple="uploadParams.limit > 1"
        :show-file-list="false"
        :auto-upload="uploadParams.autoUpload"
        :before-upload="(file) => beforeUpload(file)"
        :on-remove="handleRemove"
        :on-change="(val, fileList) => onChange(val, fileList)"
        :http-request="customRequest"
        :on-exceed="handleExceed"
        :on-progress="uploadFileProcess"
        :on-success="handleSuccess"
        :on-error="handleError"
      >
        <!--:limit="uploadParams.limit"-->
        <div
          class="ly-c-flex primary"
          :class="{ 'flex-end': true }"
          v-if="uploadType == 'button'"
        >
          <el-button type="primary" class="upload-btn" size="small">
            <svg-icon
              class-name="upload-icon"
              icon-class="icon_upload"
            ></svg-icon>
            <span>{{ defaultName }}</span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="btnTips"
              placement="top"
              v-if="btnTips"
            >
              <svg-icon
                class-name="tips-icon"
                icon-class="icon_shuoming"
              ></svg-icon>
            </el-tooltip>
          </el-button>
        </div>
        <div v-else class="avatar">
          <img v-if="imageUrl" :src="imageUrl" />
          <template v-else>
            <slot name="uploadIcon">
              <svg-icon class="upload-icon" icon-class="icon_upload"></svg-icon>
            </slot>

            <!-- <span>上传图标</span> -->
          </template>
          <!-- <i
            v-else
            class="el-icon-plus avatar-uploader-icon"
          ></i> -->
        </div>
        <div slot="tip" class="el-upload__tip" v-if="uploadParams.hasTips">
          <slot name="tips">
            仅支持{{
              uploadParams.accept.join("/")
            }}文件, 最多{{ uploadParams.limit 
            }}个, 单个文件最大{{ uploadParams.maxSize }}M
          </slot>
        </div>
      </el-upload>
    </div>
    <slot name="fileList">
      <file-list
        v-on="$listeners"
        v-bind="$attrs"
        v-model="fileList"
        :type="type"
        :downloadUrl="downloadUrl"
        :previewUrl="previewUrl"
        :fileParams="fileParams"
        @input="fileChange"
        :versionType="versionType"
        v-if="
          fileList.length > 0 &&
          uploadParams.hasFileList &&
          uploadType == 'button'
        "
        @delete="fileDel"
      ></file-list>
    </slot>
  </div>
</template>

<script>
import TextTooltip from "../TextTooltip";
import request from "../../scripts/request";
import FileList from "./FileList";
import SvgIcon from "../SvgIcon.vue";
export default {
  components: { TextTooltip, FileList, SvgIcon },
  props: {
    value: {
      type: [String, File, Object, FormData, Array],
    },
    uploadUrl: {
      type: String,
      default: "/portal/api/v1/file/create",
    },
    size: { type: String, default: "small" },
    moduleCode: {
      //模块编码必传
      type: String,
      required: true,
      default: "",
    },
    params: {
      //accept: 文件类型[]；
      type: Object,
      default: () => {
        return {
          //accept: [], 文件类型
          //customForm:Boolean, 是否自定义FormData
          //maxSize:100, 上传文件最大限制,单位MB
          //autoUpload: true, //是否在选取文件后立即进行上传
          //limit: 1, //上传文件上限
        };
      },
    },
    uploadType: {
      //用于判断是文件上传还是logo(图片)上传
      type: String,
      default: "button",
    },
    defaultName: {
      type: String,
      default: "上传文件",
    },
    type: {
      //用于判断是否禁用，或只显示文件列表
      type: String,
      default: "",
    },
    btnTips: {
      type: String,
      default: "",
    },
    checkFileExtend: {
      //checkFileExtend为上传校验其他方法，父组件向子组件传递的方法
      type: Function,
    },
    versionType: {
      type: String,
      default: "",
    },
    fileParams: {
      type: Object,
      default: () => {
        return null;
      },
    },
    //下载地址
    downloadUrl: {
      type: String,
      default: "/portal/api/v1/file/download/",
    },
    //预览地址
    previewUrl: {
      type: String,
      default: "/portal/api/v1/file/review/",
    },
  },

  data() {
    return {
      fileList: [
        // {
        //   name: "11111.doc",
        //   size: 111616,
        //   version: "申请版",
        //   fileCreatedby: "李大发",
        //   time: "2023-08-18 10:00",
        // },
      ],
      fileType: {
        word: ["doc", "docx"],
        excel: ["xls", "xlsx"],
        pdf: ["pdf"],
        ppt: ["ppt", "pptx"],
        // rar: ["rar", "zip"],
        // png: ["png", "jpg", "svg"],
      },
      imageUrl: "",
      uploadParams: {
        autoUpload: true, //是否在选取文件后立即进行上传
        customForm: false, //是否自定义FormData
        maxSize: 100, //上传文件最大限制,单位MB
        accept: [], //文件类型
        limit: 1, //上传文件上限
        hasTips: true, //是否显示提示语
        hasFileList: true, //是否显示上传列表
      },
      acceptType: "",
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val) {
          this.fileList = [];
        } else {
          if (typeof val === "string") {
            this.imageUrl = val;
          } else {
            this.fileList = val;
          }
        }
      },
    },
    params: {
      deep: true,
      immediate: true,
      handler(val) {
        this.uploadParams = { ...this.uploadParams, ...val };
      },
    },
  },
  created() {
    this.uploadParams = { ...this.uploadParams, ...this.params };
  },
  mounted() {},
  methods: {
    beforeUpload(file) {
      let uploadFiles = this.$refs.upload.uploadFiles;
      if (uploadFiles.length > this.uploadParams.limit) {
        setTimeout(() => {
          this.$message.warning(
            `当前限制上传` + this.uploadParams.limit + `个文件`
          );
        }, 1);
        return false;
      }
      return this.checkFile(file);
    },
    /**检查文件是否合规 */
    checkFile(file) {
      let fileList = this.fileList
        ? JSON.parse(JSON.stringify(this.fileList))
        : [];
      const maxSize = this.uploadParams.maxSize;
      const isType = this.uploadParams.accept
        ? this.uploadParams.accept.includes(this.getSuffix(file.name))
        : true;
      const isLt = file.size <= Number(maxSize) * 1024 * 1024;
      const noSize = file.size != 0;
      if (!isType) {
        setTimeout(() => {
          this.$message.error("文件类型错误");
        }, 1);
        return isType;
      }
      if (!isLt) {
        setTimeout(() => {
          this.$message.error("上传文件大小不能超过 " + maxSize + "MB!");
        }, 1);

        return isLt;
      }
      if (!noSize) {
        setTimeout(() => {
          this.$message.error("不允许上传空文件");
        }, 1);
        return noSize;
      }
      //checkFileExtend为上传校验其他方法，父组件向子组件传递的方法
      if (this.checkFileExtend) {
        return this.checkFileExtend(file);
      }
      if (fileList.length) {
        if (this.uploadParams.limit == 1) {
          this.fileList.splice(0, 1, file);
        } else {
          if (fileList.length >= this.uploadParams.limit) {
            setTimeout(() => {
              this.$message.warning(
                `当前限制上传` + this.uploadParams.limit + `个文件`
              );
            }, 1);
            return false;
          } else {
            return true;
          }
        }
      }
      if (!this.uploadParams.autoUpload) {
        if (isType && isLt && noSize) {
          return true;
        }
      }
    },
    // 替换同名文件
    replaceFile(file) {
      const index = this.fileList.findIndex((val) => {
        return val.name === file.name;
      });
      if (index > -1) {
        this.fileList.splice(index, 1, file);
      } else {
        this.fileList.push(file);
      }
    },

    onChange(file, fileList) {
      let flag = true;
      if (!this.uploadParams.autoUpload) {
        flag = this.checkFile(file);
        if (flag) {
          if (this.uploadParams.limit == 1 && fileList.length > 1) {
            fileList.splice(0, 1);
          }
          if (this.uploadType === "image") {
            this.imageUrl = URL.createObjectURL(file.raw);
          }
          if (!this.uploadParams.customForm) {
            let uploadData = new FormData();
            uploadData.append("file", file.raw);
            this.$emit("input", uploadData);
          } else {
            this.$emit("input", file.raw);
          }
        }
      }
    },
    //文件上传过程中的函数(在这里获取进度条的进度)
    uploadFileProcess(event, file) {
      let new_file = file;
      if (file) {
        new_file["progressPercent"] = event.percent;
        file["progressFlag"] = file && file.percentage == 100 ? false : true;
        this.fileList.forEach((item, index) => {
          if (item.uid == file.uid || file.name == item.name) {
            this.fileList.splice(index, 1, file ? file : "");
          }
        });
        this.emitParent(this.fileList, file);
      }
      // this.emitParent();
    },
    handleSuccess(response, file) {
      let flag = false;
      file.percentage = 100;
      file.progressFlag = false;
      let fileData = response ? response.data[0] : file;
      this.fileList.forEach((item, index) => {
        if (item.uid == file.uid) {
          flag = true;
          this.fileList.splice(index, 1, fileData)
        }
      });
      if (!flag) {
        this.fileList.push(fileData);
      }
      this.emitParent(this.fileList, file, "success");
    },
    /**上传失败的回调 */
    handleError(err, file) {
      let arr = [];
      this.defaultedList.filter((item) => {
        arr.push(item.name);
      });

      this.fileList.filter((item, index) => {
        item.percentage = 100;
        item.progressFlag = false;
        let name = item.name;
        if (name == file.name && !arr.includes(item.name)) {
          this.fileList.splice(index, 1);
        }
      });
      this.emitParent(this.fileList, file, "error");
    },
    emitParent(fileList, file, type) {
      let arr = [];
      let new_fileList = JSON.parse(JSON.stringify(fileList));
      if (new_fileList.length > 0) {
        new_fileList.forEach((el, index) => {
          let new_data = null;
          if (el.status != undefined && el.status == "success") {
            new_data = el.response.data[0];
          } else {
            new_data = el;
          }
          this.$set(arr, index, new_data);
        });
      } else {
        this.$set(arr, 0, file);
      }
      let data = {
        fileList: arr,
      };
      this.$emit("input", arr, type);
      this.$emit("change", data);
    },
    fileChange(fileList) {
      let data = {
        fileList: fileList,
      };
      this.$emit("change", data);
    },

    /**获取文件名后缀 */
    getSuffix(filename) {
      if (!filename) return "other";
      const pos = filename.lastIndexOf(".");
      let suffix = "";
      if (pos != -1) {
        suffix = filename.substring(pos);
      }
      return suffix.toLocaleLowerCase();
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleExceed(files, fileList) {
      // console.log(this.uploadParams.limit, "handleExceed");
      // if (this.uploadParams.limit == 1) {
      //   console.log(3333);
      //   this.$refs.upload.clearFiles();
      //   this.$nextTick(() => {
      //     this.$refs.upload.handleStart(fileList[0]);
      //   });
      // } else {
      //   this.$message.warning(
      //     `当前限制上传` + this.uploadParams.limit + `个文件`
      //   );
      // }
      this.$message.warning(
        `当前限制上传` + this.uploadParams.limit + `个文件`
      );

      // this.$message.warning(
      //   `当前限制选择` +
      //     this.uploadParams.limit +
      //     `个文件，本次选择了 ${files.length} 个文件`
      // );
    },
    /**获取图标类型 */
    getFileType(file) {
      let name = file.name;
      let fileType = file.fileType || this.getSuffix(name);
      let type = "other";
      let typeName = fileType.replace(".", "");
      for (let key in this.fileType) {
        if (this.fileType[key].includes(typeName)) {
          type = key;
        }
      }
      return require("@/assets/images/icon_" + type + ".svg");
    },
    fileDel(item, fileList) {
      let uploadFiles = this.$refs.upload.uploadFiles;
      uploadFiles.forEach((el, index) => {
        let resData = el.response ? el.response.data[0] : el;
        if (resData.uuid == item.uuid) {
          uploadFiles.splice(index, 1);
        }
      });
    },
    // 自定义上传
    customRequest(param) {
      const formData = new FormData();
      formData.append("files", param.file);
      formData.append("moduleCode", this.moduleCode);
      // 文件上传
      const _this = this;
      request({
        url: this.uploadUrl,
        headers: {
          "Content-Type": "multipart/form-data",
          // "Content-Type": "application/x-www-form-urlencoded",
        },
        data: formData,
        method: "post",
        onUploadProgress: (progressEvent) => {
          let num = ((progressEvent.loaded * 100) / progressEvent.total) | 0;
          param.onProgress({ percent: num }); //进度条
        },
      })
        .then((res) => {
          if (res.code === "00000") {
            param.onSuccess(res);
          } else {
            param.onError(res);
          }
        })
        .catch((error) => {
          param.onError(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/primary.module.scss";
.uploadList {
  margin-bottom: 12px;
  // display: flex;
  // .el-upload__tip {
  //   margin-left: 24px;
  // }
}
.upload-file {
  .el-upload__tip {
    margin-left: 8px;
    display: inline-block;
    font-size: 12px;
    margin-top: 0;
    color: #9ba8bb;
  }
}
.upload-btn {
  position: relative;
  background: #d7ecff;
  border: 1px solid $primaryColor;
  border-radius: 4px !important;
  font-family: PingFangSC-Medium;
  color: $primaryColor;
  font-weight: 500;
  .upload-icon {
    font-size: 12px;
  }
  .tips-icon {
    margin-left: 10px;
  }
}

.upload-image {
  /deep/.el-upload {
    background: $primary_hover_color;
    border: 1px dashed $primaryColor;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: $primaryColor;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 80px;
      height: auto;
      max-height: 80px;
      display: block;
    }
    /deep/.svg-icon {
      font-size: 28px;
      color: $primaryColor;
    }
  }
}
</style>
